import React, { useState } from 'react';
import { Row } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router';
import { TransitionView } from 'components/common/transition-view';
import { useRouterTransition } from 'hooks/useRouterTransition';
import { FormattedMessage, useIntl } from 'react-intl';
import { PrimaryButton } from 'components/common/PrimaryButton';
import { ConfirmMessageBox } from 'components/common/ConfirmMessageBox';
import { LoadingModal } from 'components/common/LoadingModal';
import api from 'helpers/api';

const styles = {
  headerText: {
    fontSize: '4vw',
    fontWeight: '600'
  }
};

export const GreenZoneDepositConfirm = () => {
  const t = useIntl();
  let navigate = useNavigate();
  const { state } = useLocation();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  let { transitionType, handleTransition } = useRouterTransition(navigate);

  const navTo = (url, state) =>{
    handleTransition (url, state)
  };
  
  const openLokker = () => {
    setIsSubmitting(true);
    setLoading(true);
    api.post(`${process.env.REACT_APP_API_URL}api/mar-shopping/createDeliveryAndOpenLocker`, {
      locationId: process.env.REACT_APP_LOCATION_ID,
      packageId: state?.number,
      recipientPhone: state?.receiverNumber,
      recipientName: 'MARSHOPPING', 
      size: state?.lockerSize ,
    })
      .then(function (response) {
        console.log(response);
        if (response?.data?.ResultCode === 1) {
          console.log(response?.data?.Data?.assignedLocker);
          navTo('/deposit-lokker-opened', { state: { locker: response?.data?.Data?.assignedLocker } })
        } else if (response?.data?.Description === 'Invalid PIN') {
          console.log(response?.data?.Description);
        } else {
          console.log(response?.data);
          console.log('Unknow Error');
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })    
      .finally(() => {
        setIsSubmitting(false);
        setLoading(false);
      })
  };

  return(
    <TransitionView animation="fade-down" transitionType={transitionType} className="justify-content-start position-relative">
      <LoadingModal isLoading={loading} />
      <Row className="py-5 m-0">
        <span style={styles.headerText}>
          <FormattedMessage id="app.depositConfirm" />
        </span>
      </Row>
      <Row className="mb-3 m-0">
        <ConfirmMessageBox phoneNumber={state.number} receiverPhoneNumber={state.receiverNumber} lokkerSize={state.lockerSize} />
      </Row>
      <Row className="m-0">
        <PrimaryButton text={t.messages['app.confirm']} color="yellow" onClick={isSubmitting ? () => null : () => openLokker()} isEnabled={!isSubmitting}/>
      </Row>
      <Row className="m-0">
        <PrimaryButton text={t.messages['app.cancel']} color="white" border="lightGrey" onClick={() => navTo('/pick-and-collect')}/>
      </Row>
    </TransitionView>
  )
}